import template from './user-job-preferences.html';
import userJobPreferencesController from './user-job-preferences.controller';
import './user-job-preferences.styl';

let userJobPreferencesComponent = {
  restrict: 'E',
  bindings: {
    jobPreferences: '<',
    options: '<',
  },
  template,
  controller: userJobPreferencesController,
  controllerAs: 'vm'
};

export default userJobPreferencesComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-job-preferences/user-job-preferences.component.js
 **/